module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoggedIn) ? _c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("You are Logged In")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
    attrs: {
      "id": "login-form"
    }
  }, [_c('h2', [_vm._v("Log In")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "login"
    }
  }, [(_vm.validationMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "id": "login-email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "id": "login-password",
      "name": "password",
      "size": "20",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "remember-me",
    attrs: {
      "for": "remember"
    }
  }, [_c('input', _vm._b({
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember",
      "value": "Yes",
      "checked": ""
    }
  }, 'input', _vm.rememberMe, false)), _vm._v("Remember me")]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('span', [_c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": "/Login/Forgot"
    }
  }, [_vm._v("I forgot my password!")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
    staticClass: "register-link",
    attrs: {
      "to": "/Register"
    }
  }, [_vm._v("Register new account")])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b85c256!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Login/LoginPage.vue
// module id = 900
// module chunks = 2